import Text from "components/Text";
import styled from "styled-components";
import theme from "theme";
import { colors } from "theme/colors";

export const ProfileStrengthWrapper = styled.div`
    margin-top: 24px;
    width: 100%;
    border-radius: 14px;
    padding: 30px 28px;
    background-color: #fff;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;

    @media (${theme.breakpoints.mobileL}) {
        padding: 20px 16px;
    }
`;

export const ProfileStrengthTitle = styled(Text)`
    font-weight: 700;
    color: ${colors.grey.dark};
    letter-spacing: 0.15em;
    margin-bottom: 10px;
`;

export const SubTitle = styled(Text)`
    font-weight: 500;
    color: ${colors.grey.primary};
    font-size: 14px;
    margin-bottom: 2rem;
`;

export const Steps = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
    margin-top: 1rem;
`;

export const Step = styled.div<{ isComplete?: boolean }>`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 8px;
    padding-right: 25px;
    border: 1px solid #efefef;
    border-radius: 8px;
    svg {
        color: ${({ isComplete }) =>
            isComplete ? colors.purple.primary : "#3CB006"};
    }
    ${Text.Style} {
        font-weight: 500;
        font-size: 14px;
        color: ${({ isComplete }) =>
            isComplete ? colors.grey.dark : colors.grey.secondary};
    }
    @media (${theme.breakpoints.mobileL}) {
        ${Text.Style} {
            font-size: 12px;
        }
        padding: 8px;
    }
`;
